module.exports = __webpack_public_path__ + "static/img/logo-footer.672025b3.png";